package com.havn.app.core.platform

actual fun havnIsTabletDevice(): Boolean = false

actual fun havnShouldAvoidFloatingNumericKeyboard(): Boolean = false

actual fun havnAppVersionName(): String = HAVN_ANDROID_VERSION_NAME

actual fun havnSubscriptionDisclosurePlatform(): HavnSubscriptionDisclosurePlatform =
    HavnSubscriptionDisclosurePlatform.Web
